// removed by extract-text-webpack-plugin
module.exports = {"binary_navigation_item":"FnTeVYdYxdnL4TwsMg4MG","binary_navigation_nav":"_2RYtCOTWmdnr5-0BdDgz-k","binary_navigation_sub":"_3D69_vwKmOKWOMTJXRW4e","binary_navigation_highlight":"_2OKCFLOVEyctOhy_DCoTVv","binary_navigation_sub_highlight":"K1EYOEFHNPLdkltPou2rN","binary_navigation_nav_noarrow":"_2s_zyziDZKnmHgaKmfG0e9","no_drop_down":"_2Y27xTh25AH-ymvtJaG1Sc"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryNavigation/BinaryNavigation.scss
// module id = 2301
// module chunks = 1